import { Cell } from 'modules/admin/Common';
import CommonAssetAdmin from 'modules/admin/CommonAssetAdmin';
import React from 'react';
import { connect } from 'rxbeach/react';
import { combineLatest, map } from 'rxjs';
import { formatDateday } from 'utils/dateUtils';
import CourseFormEditor from './CourseEditor';
import { course$ } from './course$';

const columns = [
  {
    header: 'Tittel',
    property: 'label',
    search: true,
    render: (e: any) => <Cell>{e.label}</Cell>
  },
  {
    header: 'Publisert',
    property: 'published',
    verticalAlign: 'middle',
    align: 'center',
    render: (e: any) => <Cell>{e.published ? '✅' : '⚠️'}</Cell>
  },
  {
    header: 'Fremhev',
    property: 'featured',
    verticalAlign: 'middle',
    align: 'center',
    render: (e: any) => <Cell>{e.featured ? '⭐️' : ''}</Cell>
  },
  {
    header: 'Tab',
    property: 'type',
    render: (e: any) => <Cell>{e.tab}</Cell>
  },
  {
    header: 'Pris',
    property: 'price',
    render: (e: any) => <Cell>{e.price}</Cell>
  },
  {
    header: 'Date',
    property: 'dates',
    render: (e: any) => <Cell>{e.dates?.map(formatDateday).join(', ')}</Cell>
  },
];

const viewModel$ = combineLatest([course$]).pipe(
  map(([{ byId }]) => ({
    byId,
    courses: Object.values(byId),
  }))
);

const CourseAdmin = ({ courses, byId }: any) => {
  return (
    <CommonAssetAdmin
      data={courses}
      byId={byId}
      columns={columns}
      Editor={CourseFormEditor}
    />
  )
}

export default connect(CourseAdmin, viewModel$);
